import { Injectable } from '@angular/core';
import { type Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { type RbacPermissions } from '@common/types/rbac-permissions.type';
import { type HttpDataResponse } from '@common/types/http-response.type';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class RbacPermissionsHttpService extends BaseHttpService {
    public getPermissions(): Observable<RbacPermissions> {
        return this.http.get<HttpDataResponse<RbacPermissions>>('/landing-pages/ajax/get-user-permissions/').pipe(
            shareReplay(),
            map((res: HttpDataResponse<RbacPermissions>) => {
                return res.data;
            })
        );
    }
}
